import { useEffect, useState, useRef } from 'react';
import { Input } from '@material-tailwind/react';

const InputWithSearchFunction = (props: {
  className?: string;
  arrAllOption: any;
  label: string;
  value: string;
  errorMessage: string;
  onChange: (updatedValue: string) => void;
  onBlur: () => void;
}) => {
  const { className, label, value, errorMessage, arrAllOption, onChange, onBlur } = props;
  const [arrFilteredOption, setArrFilteredOption] = useState(arrAllOption);
  const [showOption, setShowOption] = useState(false);
  const ref: any = useRef();

  /**
   * This function is attached to input component onChange callback which filters the arrAllOption by
   * the search input (case insensitive). Valid input can be manually typed or selected from the dropdown list
   * @param manualInput - contains input string manually typed in by user
   */
  const updateFilteredOption = (manualInput: string) => {
    const newManualInputInLowerCase = manualInput.toLowerCase();
    const arrNewFilteredOption = arrAllOption.filter((option: any) =>
      option.toLowerCase().includes(newManualInputInLowerCase)
    );

    setArrFilteredOption(arrNewFilteredOption);
    if (!showOption) {
      setShowOption(true);
    }
  };

  useEffect(() => {
    const listener = (event: any) => {
      if (!ref.current.contains(event.target)) {
        setShowOption(false);
      }
    };
    document.addEventListener('click', listener);
    document.addEventListener('focusin', listener);
    return () => {
      document.removeEventListener('click', listener);
      document.removeEventListener('focusin', listener);
    };
  }, []);

  return (
    <div className={`${className}`} ref={ref}>
      <Input
        error={!!errorMessage}
        label={label}
        value={value}
        onFocus={() => setShowOption(true)}
        onChange={(event) => {
          onChange(event.target.value);
          updateFilteredOption(event.target.value);
        }}
        onBlur={onBlur}
        onKeyDown={(event) => {
          if (event.code === 'Tab' && arrFilteredOption.length > 0) {
            onChange(arrFilteredOption[0]);
          }
        }}
      />
      {showOption && (
        <ul className="absolute bg-gray-100 shadow-lg hover:shadow w-full rounded-xl z-50 overflow-auto max-h-40">
          {arrFilteredOption.map((option: any, index: number) => (
            <li
              className="hover:bg-gray-200 px-4 py-2"
              key={`${index} ${option.name}`}
              onMouseDown={() => onChange(option)}
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default InputWithSearchFunction;
